import axios from 'axios';
import authService from './authService';

const API_URL = '/api/';

class UnionService {
  /**
   * Get list of all unions the current user has access to
   */
  async getUserUnions() {
    const response = await axios.get(API_URL + 'unions/mine/', {
      headers: authService.authHeader()
    });
    // Returns { unions: [...], active_union_id: ... }
    return response.data;
  }

  /**
   * Switch the active union
   */
  async switchUnion(unionId) {
    const response = await axios.post(
      API_URL + 'unions/switch/',
      { union_id: unionId },
      { headers: authService.authHeader() }
    );
    return response.data;
  }

  /**
   * Get information about the currently active union
   */
  async getActiveUnion() {
    const response = await axios.get(API_URL + 'unions/active/', {
      headers: authService.authHeader()
    });
    return response.data;
  }
}

const unionService = new UnionService();
export default unionService;
